import { render, staticRenderFns } from "./PaiePreview.vue?vue&type=template&id=5bee2bd0&"
import script from "./PaiePreview.vue?vue&type=script&lang=js&"
export * from "./PaiePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports